<template>
    <div class="csv_config_style">
        <h3 class="text-center">{{ $t('page.shipping.ShippingMethodEdit') }}</h3>
        <div class="form-group row">
            <label class="col-md-4 control-label">{{ $t('page.shipping.shipper') }}</label>
            <div class="col-md-7 inputGroupContainer">
                <div class="input-group">
                    <span class="input-group-addon"></span>

                    <select class="form-control col-md-12" id="shipper_id" name="shipper_id" v-model="shipper">
                        <option v-for="(shipper, index) in availableShippers" :value="shipper">{{shipper.name}}</option>
                    </select>

                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">{{ $t('page.shipping.is_express') }}</label>
            <div class="col-md-7 inputGroupContainer">
                <div class="input-group">
                    <span class="input-group-addon"></span>

                    <select class="form-control col-md-12" id="shipper_express" name="shipper_express"
                            v-model="is_express">
                        <option value="not selected" selected disabled>{{$t('page.csv.weahlen') }}</option>
                        <option :value="true">{{$t('page.shipping.express_true') }}</option>
                        <option :value="false">{{$t('page.shipping.express_false') }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">{{ $t('page.shipping.int_name') }}</label>
            <div class="col-md-7 inputGroupContainer">
                <div class="input-group">
                    <span class="input-group-addon"></span>

                    <input type="text" class="form-control col-md-12" id="shipper_name"
                           aria-describedby="host" placeholder=""
                           name="shipper_name" value="" v-model="name">
                </div>
            </div>
        </div>

        <div class="form-group row btn-left">
            <button class="btn btn-primary" @click="submit()">{{ $t('page.shipping.saveMethod') }}</button>
        </div>


    </div>

</template>

<script>
    import shippingMethodMappingService from "../../services/shippingMethodMappingService";
    import shopService from "../../services/shopService";
    import shippingMethodService from "../../services/shippingMethodService";
    import shipperService from "../../services/shipperService";

    export default {
        name: "ShippingMethodMappingEdit",
        props: [
            'shippingMethodId',
        ],
        data() {
            return {
                availableShippers: [],
                shipper: {},
                name: null,
                is_express: null,
            }

        },
        methods: {
            getShippingMethod() {
                let self = this;
                shippingMethodService.geShippingMethod(this.shippingMethodId).then(
                    (response) => {
                        self.shipper = response.shipper;
                        self.is_express = response.is_express;
                        self.name = response.name;
                    });
            },
            getAvailableShippers() {
                shipperService.getAll().then(
                    (response) => {
                        this.availableShippers = response;
                    });
            },
            isCreated(shipping_method) {
                if (this.shippingMethodId == null) {
                    shippingMethodService.create(shipping_method);
                } else {
                    shippingMethodService.update(this.shippingMethodId,shipping_method);
                }
            },
            submit(event) {
                this.shipping_method = {
                    shipper_id: this.shipper.id,
                    name : this.name,
                    is_express : this.is_express
                }
                this.isCreated(this.shipping_method);
                this.$eventBus.$emit('shipping-method-create-edit');

            }
        },
        beforeMount() {
            this.getShippingMethod();
            this.getAvailableShippers();

        }
    }
</script>

<style scoped>
    .btn-left {
        margin-left: 76%;
    }
</style>